// /frontend/src/utils/validateMediaByUrl.js

/**
 * Validate a media URL when we don’t have the raw File object.
 * Returns { ok:boolean, error?:string }
 */
export async function validateMediaByUrl(url, { format }) {
  // quick ext test – if not a video, it’s fine for Story; Reel needs video
  if (!/\.(mp4|mov|m4v|avi|wmv)(\?|$)/i.test(url)) {
    if (format === 'reel') return { ok: false, error: 'Reels require a video file.' };
    return { ok: true }; // photo Story is allowed
  }

  // probe video metadata
  const meta = await new Promise((resolve) => {
    const v = document.createElement('video');
    v.preload = 'metadata';
    v.onloadedmetadata = () => {
      resolve({ w: v.videoWidth, h: v.videoHeight, d: v.duration });
      URL.revokeObjectURL(v.src);
    };
    v.onerror = () => resolve(null);
    v.src = url;
  });
  if (!meta) return { ok: false, error: 'Could not read video metadata.' };

  const { w, h, d } = meta;
  const isLandscape = w > h;

  if (format === 'story' || format === 'reel') {
    if (isLandscape)  return { ok:false, error:'Stories/Reels must be vertical (9×16).' };
    if (h < 960)      return { ok:false, error:'Vertical resolution must be ≥ 960 px.' };
    if (d < 3 || d > 90)
      return { ok:false, error:'Video length must be 3–90 seconds.' };
    if (format === 'story' && d > 60)
      return { ok:false, error:'Story videos can’t exceed 60 seconds.' };
  }
  return { ok: true };
}
